import React from "react";
import { useState } from "react";

interface InquiryViewItemProps {
  title: string;
  type: string;
  id: string;
  placeholder?: string;
  multiline?: boolean 
  height?: string;
}

interface InquiryViewProps {
  items: InquiryViewItemProps[];
  values: Record<string, string>;
  onChange: (field: string, value: string) => void;
  phoneValue?: string;
  onPhoneChange?: (newVal: string) => void;
}

const InquiryView = ({
  items, values, onChange,
  phoneValue, onPhoneChange
}: InquiryViewProps) => {
  return (
    <div className="flex flex-col gap-4">
      {items.map(item => {
        const isPhoneField = item.id === "manager_phone"
        return (
          <div key={item.id}>
            <label htmlFor={item.id} className="block text-gray-500 text-xs mb-1">
              {item.title}
            </label>

            {/* ① 휴대폰 번호만 phoneValue/onPhoneChange 로 바인딩 */}
            {isPhoneField && phoneValue !== undefined && onPhoneChange ? (
              <input
                id="manager_phone"
                type="text"
                placeholder={item.placeholder}
                value={phoneValue}
                onChange={e => onPhoneChange(e.target.value)}
                className="w-full border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 px-3 py-2"
                required
              />

            ) : item.multiline ? (
              <textarea
                id={item.id}
                rows={6}
                placeholder={item.placeholder}
                value={values[item.id] || ""}
                onChange={e => onChange(item.id, e.target.value)}
                className="w-full border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 p-3 resize-none"
                required
              />

            ) : (
              <input
                id={item.id}
                type={item.type}
                placeholder={item.placeholder}
                value={values[item.id] || ""}
                onChange={e => onChange(item.id, e.target.value)}
                className="w-full border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 px-3 py-2"
                required
              />
            )}
          </div>
        )
      })}
    </div>
  )
}

export default InquiryView;
